import React, { useState, useEffect } from "react";
import image from "../../../images/footer.png";
import "./Link.css";
import { useUUIDData } from "../../../context/UUIDContext";

const messages = [
  "Смотри, что я случайно нашла... 😇 [ссылка]",
  "Намекаю.. [ссылка]",
  "Маленький спойлер к счастливому вечеру: [ссылка]",
  "Если бы ты мог прочитать мои мысли — ты бы увидел это [ссылка]",
  "Оставлю здесь одну красивую ссылку. А дальше — как почувствуешь 💌 [ссылка]",
  "Не для намёка. Для вдохновения 🌸 [ссылка]",
  'Маленький путь к большому "вау". [ссылка]',
  "На всякий случай, вот цветы которые мне нравятся [ссылка]",
  "Как дела? [ссылка]",
  "Нашла удобный сайт, где выбрала цветы, которые мне нравятся.. [ссылка]",
  "Не угадаешь, что это. Но я точно хочу, что бы ты это открыл.. [ссылка]",
  "Интуиция говорит: ты оценишь. [ссылка]",
  "Дальше только действия. [ссылка]",
  "Реши сам: мимо пройти или запомнить. [ссылка]",
  "Ты видел какие красивые букеты они делают? [ссылка]",
  "Есть вещи, которые не объясняют. Их просто отправляют. [ссылка]",
  "Слишком тонко? [ссылка]",
];

function Link() {
  const { uuid } = useUUIDData();
  const [currentIndex, setCurrentIndex] = useState(0);
  const domainName = process.env.REACT_APP_DOMAIN;
  const [displayedMessage, setDisplayedMessage] = useState("");

  useEffect(() => {
    const initialMessage = messages[0].replace(
      "[ссылка]",
      `${domainName}${uuid}`
    );
    setDisplayedMessage(initialMessage);
  }, [uuid]);

  const changeMessage = () => {
    const nextIndex = (currentIndex + 1) % messages.length;
    setCurrentIndex(nextIndex);
    if (uuid) {
      const newMessage = messages[nextIndex].replace(
        "[ссылка]",
        `${domainName}${uuid}`
      );
      setDisplayedMessage(newMessage);
    }
  };

  const copyMessage = async () => {
    try {
      await navigator.clipboard.writeText(displayedMessage);
      alert("Скопировано в буфер обмена!");
    } catch (err) {
      alert("Не удалось скопировать 😢");
    }
  };

  const sendMessage = async () => {
    if (!navigator.share) {
      alert("Ваш браузер не поддерживает функцию общего доступа.");
      return;
    }

    try {
      await navigator.share({
        title: "🌸 Цветочный намек",
        text: displayedMessage,
      });
    } catch (err) {
      console.error("Ошибка при отправке:", err);
    }
  };

  const isDisabled = !uuid;

  return (
    <div className="link">
      <div className="container">
        <div className="link__container">
          <h3 className="link__header">
            теперь главное не боятся <br /> своих желаний ..
          </h3>

          <div className="link__link-wrapper">
            <p className="link__link">
              {isDisabled
                ? "Ссылка появится после оформления"
                : displayedMessage}
            </p>
          </div>

          <div className="link__btn-wrapper">
            <button
              className="link__btn"
              onClick={changeMessage}
              disabled={isDisabled}
            >
              поменять текст
            </button>
            <button
              className="link__btn"
              onClick={sendMessage}
              disabled={isDisabled}
            >
              отправить
            </button>

            <button
              className="link__btn"
              onClick={copyMessage}
              disabled={isDisabled}
            >
              скопировать
            </button>
          </div>

          <p className="link__second-header">если вдруг, кто-то тормоз..</p>

          <div className="link__img-wrapper">
            <img src={image} alt="Footer" className="link__img" />
          </div>

          <div className="link__footer-wrapper">
            <a
              href="https://lovflow.ru/"
              target="_blank"
              rel="noreferrer"
              className="link__footer-text"
            >
              закажу сама..
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Link;
